import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type AvatarSize = 'sm' | 'md' | 'lg' | 'xl';

/** Palette stable de couleurs attribuées par hachage du nom. */
const AVATAR_COLORS = [
  '#0d9488',
  '#7c3aed',
  '#db2777',
  '#ea580c',
  '#2563eb',
  '#16a34a',
  '#9333ea',
  '#0891b2',
] as const;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-avatar',
  styleUrl: './avatar.scss',
  templateUrl: './avatar.html',
})
export class AvatarComponent {
  /** Nom de la personne (utilisé pour les initiales et la couleur). */
  readonly name = input('');

  /** URL de l'image (optionnelle — sinon initiales). */
  readonly src = input('');

  /** Taille de l'avatar. */
  readonly size = input<AvatarSize>('md');

  /** Couleur d'arrière-plan personnalisée (sinon dérivée du nom). */
  readonly color = input('');

  protected readonly initials = computed(() => {
    const parts = this.name()
      .trim()
      .split(/\s+/)
      .filter((part) => part.length > 0);
    if (parts.length === 0) {
      return '?';
    }
    const first = parts[0].charAt(0);
    const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (first + last).toUpperCase();
  });

  protected readonly backgroundColor = computed(() => {
    if (this.color()) {
      return this.color();
    }
    const name = this.name() || '?';
    let hash = 0;
    for (let i = 0; i < name.length; i += 1) {
      hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
    }
    return AVATAR_COLORS[hash % AVATAR_COLORS.length];
  });
}
